import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { X, Wifi, Coffee, KeyRound, SlidersHorizontal } from "lucide-react";

// Full-screen "turn the tablet to the guest" view: door PIN, domotica PIN, room QR, Wi-Fi, breakfast.
export function ShowGuestModal({ item, settings, onClose }) {
  if (!item) return null;
  const roomUrl = `${window.location.origin}/room/${item.room.slug}`;
  const fmt = (d) => (d ? d.split("-").reverse().join("/") : "");
  return (
    <div className="fixed inset-0 z-50 bg-[#4a1c17] text-[#f7ebdf] overflow-y-auto" data-testid="show-guest-modal">
      <button onClick={onClose} className="absolute top-4 right-4 h-12 w-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center" data-testid="show-guest-close" aria-label="Chiudi">
        <X className="h-6 w-6" />
      </button>
      <div className="min-h-screen max-w-5xl mx-auto px-6 py-10 flex flex-col items-center justify-center gap-8">
        <div className="text-center">
          <p className="text-sm uppercase tracking-[0.3em] text-[#C48B31]">Benvenuti</p>
          <h1 className="font-serif text-3xl sm:text-5xl font-bold mt-2">{item.guest}</h1>
          <p className="mt-2 text-base sm:text-lg text-[#f7ebdf]/80">Camera <b>{item.room.name}</b> · {fmt(item.start)} → {fmt(item.end)}</p>
        </div>

        <div className="w-full grid grid-cols-1 md:grid-cols-[1fr_auto] gap-6 items-stretch">
          <div className="rounded-3xl bg-white text-[#2b1410] p-6 sm:p-8 flex flex-col gap-6">
            <div>
              <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#7c5a4e]"><KeyRound className="h-4 w-4 text-[#C48B31]" /> Codice porta</div>
              <div className="mt-2 font-mono text-5xl sm:text-7xl font-bold tracking-[0.25em] text-[#4a1c17]" data-testid="show-guest-pin">{item.pin ? item.pin.split("").join("") : "—"}</div>
              <p className="mt-1 text-sm text-[#7c5a4e]">Digita il codice sulla tastiera e conferma con <b>#</b>.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <Tile icon={SlidersHorizontal} label="PIN domotica" value={item.domotica_pin || "—"} hint="Luci, TV e clima dalla pagina camera" testId="show-guest-domotica" />
              <Tile icon={Wifi} label="Wi-Fi" value={settings?.wifi_password || "—"} hint="Password per tutte le reti" mid testId="show-guest-wifi" />
              <Tile icon={Coffee} label="Colazione" value={settings?.breakfast_text || "—"} small testId="show-guest-breakfast" />
            </div>
            {settings?.welcome_note && <p className="text-sm text-[#7c5a4e] italic">{settings.welcome_note}</p>}
          </div>
          <div className="rounded-3xl bg-white p-6 flex flex-col items-center justify-center gap-3 md:w-72">
            <QRCodeSVG value={roomUrl} size={200} fgColor="#2b1410" bgColor="#ffffff" level="M" />
            <p className="text-center text-xs text-[#7c5a4e] leading-snug">Inquadra per aprire la <b>pagina della camera</b>: domotica, menu e richieste alla reception.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function Tile({ icon: Icon, label, value, hint, small, mid, testId }) {
  return (
    <div className="rounded-2xl bg-[#faf3ee] border border-[#e8dcc8] p-4" data-testid={testId}>
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-[#7c5a4e]"><Icon className="h-3.5 w-3.5 text-[#C48B31]" /> {label}</div>
      <div className={`mt-1 font-bold text-[#2b1410] break-words ${small ? "text-lg" : mid ? "text-2xl font-mono break-all" : "text-2xl sm:text-3xl font-mono tracking-wider"}`}>{value}</div>
      {hint && <p className="mt-1 text-[11px] text-[#7c5a4e]">{hint}</p>}
    </div>
  );
}
